import React from 'react';
import { useTranslation } from 'next-i18next';

import TopEmbelish1 from '@public/images/newAboutUs/mission-card-top-embelish-1.png';
import TopEmbelish2 from '@public/images/newAboutUs/mission-card-top-embelish-2.png';
import MissionIcon1 from '@public/images/newAboutUs/mission-icon-1.png';
import MissionIcon2 from '@public/images/newAboutUs/Mission-icon-2.png';
import MissionImg1 from '@public/images/newAboutUs/mission-img-1.png';
import MissionImg2 from '@public/images/newAboutUs/mission-img-2.png';

import Card from './Card';

const Mission: React.FC = () => {
  const { t } = useTranslation('aboutus');
  const list = [
    {
      key: '1',
      title: t('悟空使命-标题'),
      des: t('悟空使命-内容'),
      icon: MissionIcon1,
      img: MissionImg1,
      className: "bg-[url('/images/newAboutUs/mission-card-embelish.png')] bg-wk-yellow-200",
      topEmbelish: TopEmbelish1,
    },
    {
      key: '2',
      title: t('悟空愿景-标题'),
      des: t('悟空愿景-内容'),
      icon: MissionIcon2,
      img: MissionImg2,
      className: "bg-[url('/images/newAboutUs/mission-card-embelish-2.png')] bg-wk-purple-100",
      reverse: true,
      topEmbelish: TopEmbelish2,
    },
  ];
  return (
    <div className="mx-auto max-w-[850px] xl:max-w-[1164px]">
      {/* 第一行：卡片+图片 */}
      {list.map((item) => (
        <Card
          className={item.className}
          key={item.key}
          title={item.title}
          des={item.des}
          icon={item.icon}
          img={item.img}
          reverse={item.reverse}
          topEmbelish={item.topEmbelish}
        />
      ))}
    </div>
  );
};

export default Mission;
